import { render, staticRenderFns } from "./PointsCalculation.vue?vue&type=template&id=1fe9a17b&scoped=true"
import script from "./PointsCalculation.vue?vue&type=script&lang=js"
export * from "./PointsCalculation.vue?vue&type=script&lang=js"
import style0 from "./PointsCalculation.vue?vue&type=style&index=0&id=1fe9a17b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe9a17b",
  null
  
)

export default component.exports